import { render, staticRenderFns } from "./ArchivesOverviewView.vue?vue&type=template&id=7ad8d422&"
import script from "./ArchivesOverviewView.vue?vue&type=script&lang=js&"
export * from "./ArchivesOverviewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports